import { RootState } from 'src/store/store'
import { LoginProps } from 'src/views/Account/Login'
import PinInputForm from 'src/components/atomic/organisms/views/Login/PinInputForm'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import FacebookLoginForm from 'src/components/atomic/organisms/views/Login/FacebookLoginForm'
import GoogleLoginForm from 'src/components/atomic/organisms/views/Login/GoogleLoginForm'
import styled from 'styled-components'
import ErrTextBox from 'src/components/atomic/Molecules/ErrTextBox'

const LoginTemplate = (props: { data: LoginProps }) => {
  const { Status } = useAppSelector((state: RootState) => state.LoginPage)
  const { errText } = useAppSelector((state: RootState) => state.common)

  return (
    <>
      {Status === 'default' ? (
        <>
          <LoginWrap>
            <GoogleLoginForm data={props.data} />
            <FacebookLoginForm data={props.data} />
          </LoginWrap>
          <ErrTextBox>{errText}</ErrTextBox>
        </>
      ) : (
        <PinInputForm data={props.data} />
      )}
    </>
  )
}
export default LoginTemplate

const LoginWrap = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`
